export default "__VITE_ASSET__CqqVM34C__"